import { useEffect } from 'react';
import { useStore } from '../core/store';
import { useTranslation } from '../core/utils/translations';
import { LoadableStatus } from '../mobx-utils';

export function useWeatherForecast() {
  const store = useStore();
  const { BookingStore } = useStore();
  const { forecastSummary: forecast } = store.weather;

  const { i18n } = useTranslation();

  useEffect(() => {
    async function fetchForecast() {
      let uniqueGeoLocations = null;
      let language = i18n.language.substring(0, 2).toLowerCase();

      const waitForGeoLocation = setInterval(async () => {
        if (BookingStore?.booking?.status === LoadableStatus.done) {
          uniqueGeoLocations = BookingStore?.validGeoDataFromHotels;
          clearInterval(waitForGeoLocation);
        }

        if (uniqueGeoLocations?.length) {
          await forecast.fetch(uniqueGeoLocations, language);
        } else {
          // TODO: handle error (no geo location in reservation)
          // let city = store.reservation.pickUpStation?.address?.city;
          return null;
        }
      }, 100);
    }
    fetchForecast();
  }, []);

  return forecast;
}
